import React from 'react';
import PropTypes from 'prop-types';
import { generateHTMLIdFromKeyPath } from 'utils/idUtils';

const CheckBoxContent = (props) => {
  const {
    id,
    children = null,
    disabled = false,
    invalid = false,
    value,
    labelledBy,
    className = '',
    onChange,
  } = props;

  return (
    <div className="form-check">
      <input
        id={id}
        key="1"
        aria-labelledby={labelledBy}
        type="checkbox"
        disabled={disabled}
        className={`form-check-input taxi-checkbox ${className}${invalid ? ' is-invalid' : ''}`}
        checked={value}
        onChange={onChange}
      />
      {children}
    </div>
  );
};

export default function CheckBoxAttributes(props) {
  const {
    children = '',
    disabled = false,
    invalid = false,
    value,
    labelledBy = '',
    labelClassName = '',
    className = '',
    keyPath = [],
    fieldType = 'tx-attr',
    onCheckBoxChange,
  } = props;

  const inputId = generateHTMLIdFromKeyPath(keyPath, fieldType);
  const onChange = (event) => onCheckBoxChange(keyPath, event.target.checked);

  const checkboxProps = {
    id: inputId,
    labelledBy,
    value,
    invalid,
    disabled,
    className,
    onChange,
  };

  if (!children) return <CheckBoxContent {...checkboxProps} />;

  return (
    <CheckBoxContent {...checkboxProps} labelledBy={`${inputId}-label`}>
      <label key="2" className={`ml-1 ${labelClassName}`} htmlFor={inputId} id={`${inputId}-label`}>
        {children}
      </label>
    </CheckBoxContent>
  );
}

CheckBoxContent.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.element,
  disabled: PropTypes.bool,
  invalid: PropTypes.bool,
  value: PropTypes.bool.isRequired,
  labelledBy: PropTypes.string.isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

CheckBoxAttributes.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  invalid: PropTypes.bool,
  fieldType: PropTypes.string,
  keyPath: PropTypes.array,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.element]),
  labelClassName: PropTypes.string,
  labelledBy: PropTypes.string,
  onCheckBoxChange: PropTypes.func.isRequired,
  value: PropTypes.bool.isRequired,
};
